export default __webpack_public_path__ + "2407d6a5b40adf2a0c8feaaf00320917.png";